"use client";

import React, { Dispatch, createContext, useReducer } from "react";


type BetslipItem = {
    selectionId: number
    event: string
    market: string
    selection: string
    stake: number
}

type StateType = {
    betslip: BetslipItem[]
}

type ActionType = {
    type: string
    betslipItem?: BetslipItem
}

// Governance: Only non-sensitive betslip data is stored in localStorage. No personal info or tokens.
function sanitizeBetslip(betslip: BetslipItem[]): BetslipItem[] {
    return betslip.map(item => ({
        selectionId: Number(item.selectionId),
        event: String(item.event),
        market: String(item.market),
        selection: String(item.selection),
        stake: Number(item.stake)
    }));
}

const initialState: StateType = {
    betslip: typeof window !== 'undefined' ? sanitizeBetslip(JSON.parse(localStorage.getItem("betslip") ?? '[]')) : []
}

const reducer = (state: StateType, action: ActionType) => {
    switch(action.type) {
        case "ADD":
            if (action.betslipItem) {
                state.betslip = state.betslip.filter((item) => {
                    return item.selectionId !== action.betslipItem?.selectionId;
                });
                state.betslip.push(action.betslipItem);
                localStorage.setItem('betslip', JSON.stringify(sanitizeBetslip(state.betslip)));
            }
            return {...state};
        default:
            return {...state};
    }
}

export const BetslipContext = createContext<{
    state: StateType,
    dispatch: Dispatch<ActionType>
}>({state: initialState, dispatch: () => null});

export const BetslipContextProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <BetslipContext.Provider value={{state, dispatch}}>
            {children}
        </BetslipContext.Provider>
    );
};
